import * as Yup from 'yup'

export const Validation = Yup.object().shape({
  messageBody: Yup.string().required('Message body is required'),
})
